
export default {
  name: 'affiliator-avs',
  props: {
    withVariants: {
      type: Boolean,
      default: false,
    },
  },
};
